import { render } from "./Index.vue?vue&type=template&id=1b5deace&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=1b5deace&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1b5deace"

export default script